import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { FlammableAtexPermitQuestionnaireFlat } from "../models/flammable-atex-permit-questionnaire.model";

@Injectable({ providedIn: "root" })
export class FlammableAtexPermitQuestionnaireService {
    constructor(private httpClient: HttpClient) {}

    public getQuestionnaireFlat(permitId: number): Observable<FlammableAtexPermitQuestionnaireFlat> {
        return this.httpClient.get<FlammableAtexPermitQuestionnaireFlat>("/api/Permit/GetFlammableAtexPermitQuestionnaire", {
            params: {
                permitId: permitId,
            },
        });
    }
}
